exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.payment-links-modal.dark-top .modal-header {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.payment-links-modal .modal-lg {\n  max-width: 700px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-3a157e6a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/tools/modal/PaymentLinkDetails.vue
// module id = 1565
// module chunks = 0